import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import {
  API_TYPE_AD_USERS_FOR_ACCOUNTS,
  API_TYPE_COMPANIES_FOR_ACCOUNTS,
  API_TYPE_COMPANIES_FOR_GZ_FRAT_PACKAGES,
  API_TYPE_COMPANIES_FOR_GZ_PACKAGES,
  API_TYPE_COMPANIES_FOR_GZ_TAGS,
  API_TYPE_COMPANY_FILTER,
  API_TYPE_DASHBOARD,
  API_TYPE_DEVICE_FILTER_RISK_MANAGEMENT,
  API_TYPE_RISK_MANAGEMENT,
  API_TYPE_USER_FILTER_RISK_MANAGEMENT,
  API_TYPE_EASM,
  API_TYPE_DASHBOARD_ASM,
  API_TYPE_POLICY_FILTER,
  API_TYPE_COMPANIES_FOR_VMWARE_INTEGRATIONS,
  API_TYPE_DASHBOARD_EXECUTIVE_SUMMARY,
  API_TYPE_RAW_EVENTS,
  API_TYPE_PHASR,
  API_TYPE_INTEGRATION_PROFILES_FOR_VMWARE,
  API_TYPE_PHASR_BEHAVIORAL_IDENTITIES,
  API_TYPE_COMPANIES_FOR_MDR_CONTACT,
  API_TYPE_ACCOUNTS_FOR_MDR_CONTACT,
  API_TYPE_COMPANIES_FOR_TELEMETRY_EXCLUSIONS,
  API_TYPE_COMPANIES_FOR_CONTAINER_IMAGE_SCANNER_INTEGRATIONS,
} from '../../../webcomponents.constants';
import { CompaniesForGzTagsDataProvider } from '../dataProvider/company/CompaniesForGzTagsDataProvider';
import { CompaniesForAccountsDataProvider } from '../dataProvider/company/CompaniesForAccountsDataProvider';
import { ADUsersForAccountsDataProvider } from '../dataProvider/ADUser/ADUsersForAccountsDataProvider';
import { CompaniesForGzPackagesDataProvider } from '../dataProvider/company/CompaniesForGzPackagesDataProvider';
import { CompaniesForGzFratPackagesDataProvider } from '../dataProvider/company/CompaniesForGzFratPackagesDataProvider';
import { CompanyFilterDashboardDataProvider } from '../dataProvider/company/CompanyFilterDashboardDataProvider';
import { CompanyFilterForGzRiskManagementDataProvider } from '../dataProvider/company/CompanyFilterForGzRiskManagementDataProvider';
import { DeviceFilterForGzRiskManagementDataProvider } from '../dataProvider/riskManagement/DeviceFilterForGzRiskManagementDataProvider';
import { UserFilterForGzRiskManagementDataProvider } from '../dataProvider/riskManagement/UserFilterForGzRiskManagementDataProvider';
import { CompaniesForEasmDataProvider } from '../dataProvider/company/CompaniesForEasmDataProvider';
import { CompanyFilterDashboardAsmDataProvider } from '../dataProvider/company/CompanyFilterDashboardAsmDataProvider';
import { PolicyFilterDataProvider } from '../dataProvider/policies/PolicyFilterDataProvider';
import { CompaniesFilterDataProvider } from '../dataProvider/company/CompaniesFilterDataProvider';
import { CompaniesForVmwareIntegrationsDataProvider } from '../dataProvider/company/CompaniesForVmwareIntegrationsDataProvider';
import { CompanyFilterDashboardEsDataProvider } from '../dataProvider/company/CompanyFilterDashboardEsDataProvider';
import { CompanyFilterForRawEventsDataProvider } from '../dataProvider/company/CompanyFilterForRawEventsDataProvider';
import { CompaniesForPhasrDataProvider } from '../dataProvider/company/CompaniesForPhasrDataProvider';
import { IntegrationProfilesForVmware } from '../dataProvider/integrations/IntegrationProfilesForVmware';
import { PhasrBehavioralIdentitiesDataProvider } from '../dataProvider/phasr/PhasrBehavioralIdentitiesDataProvider';
import { CompaniesForMdrContactDataProvider } from '../dataProvider/company/CompaniesForMdrContactDataProvider';
import { AccountsForMdrContactDataProvider } from '../dataProvider/company/AccountsForMdrContactDataProvider';
import { CompanyFilterTelemetryExclusionsDataProvider } from '../dataProvider/company/CompanyFilterTelemetryExclusionsDataProvider';
import { CompaniesForContainerImageScannerIntegrationsDataProvider } from '../dataProvider/company/CompaniesForContainerImageScannerIntegrationsDataProvider';

export class GzSingleSelectComplexDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_COMPANIES_FOR_GZ_TAGS, CompaniesForGzTagsDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_ACCOUNTS, CompaniesForAccountsDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_MDR_CONTACT, CompaniesForMdrContactDataProvider);
    this.map.set(API_TYPE_ACCOUNTS_FOR_MDR_CONTACT, AccountsForMdrContactDataProvider);
    this.map.set(API_TYPE_AD_USERS_FOR_ACCOUNTS, ADUsersForAccountsDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_GZ_PACKAGES, CompaniesForGzPackagesDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_GZ_FRAT_PACKAGES, CompaniesForGzFratPackagesDataProvider);
    this.map.set(API_TYPE_DASHBOARD, CompanyFilterDashboardDataProvider);
    this.map.set(API_TYPE_RISK_MANAGEMENT, CompanyFilterForGzRiskManagementDataProvider);
    this.map.set(API_TYPE_DEVICE_FILTER_RISK_MANAGEMENT, DeviceFilterForGzRiskManagementDataProvider);
    this.map.set(API_TYPE_USER_FILTER_RISK_MANAGEMENT, UserFilterForGzRiskManagementDataProvider);
    this.map.set(API_TYPE_EASM, CompaniesForEasmDataProvider);
    this.map.set(API_TYPE_DASHBOARD_ASM, CompanyFilterDashboardAsmDataProvider);
    this.map.set(API_TYPE_POLICY_FILTER, PolicyFilterDataProvider);
    this.map.set(API_TYPE_COMPANY_FILTER, CompaniesFilterDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_VMWARE_INTEGRATIONS, CompaniesForVmwareIntegrationsDataProvider);
    this.map.set(
      API_TYPE_COMPANIES_FOR_CONTAINER_IMAGE_SCANNER_INTEGRATIONS,
      CompaniesForContainerImageScannerIntegrationsDataProvider
    );
    this.map.set(API_TYPE_INTEGRATION_PROFILES_FOR_VMWARE, IntegrationProfilesForVmware);
    this.map.set(API_TYPE_DASHBOARD_EXECUTIVE_SUMMARY, CompanyFilterDashboardEsDataProvider);
    this.map.set(API_TYPE_RAW_EVENTS, CompanyFilterForRawEventsDataProvider);
    this.map.set(API_TYPE_PHASR, CompaniesForPhasrDataProvider);
    this.map.set(API_TYPE_PHASR_BEHAVIORAL_IDENTITIES, PhasrBehavioralIdentitiesDataProvider);
    this.map.set(API_TYPE_COMPANIES_FOR_TELEMETRY_EXCLUSIONS, CompanyFilterTelemetryExclusionsDataProvider);
  }
}
